function asArray(value) {
    return Array.isArray(value) ? value : [];
}

function cloneRequestData(data) {
    const source = data || {};
    const clone = JSON.parse(JSON.stringify(source));
    if (!Array.isArray(clone.files)) {
        clone.files = [];
    }
    if (!Array.isArray(clone.items)) {
        clone.items = [];
    }
    return clone;
}

function normalizeActionsData(actionsData) {
    const source = actionsData || {};

    return {
        isAdmin: source.isAdmin === true,
        currentUserRole: source.currentUserRole || null,
        rolePermissions: source.rolePermissions || source.permissions || {},
        adminPermissions: source.adminPermissions || source.permissions || {},
        roleAvailableActions: source.roleActions || source.roleAvailableActions || source.actions || [],
        adminAvailableActions: source.adminActions || source.adminAvailableActions || source.actions || [],
        roleActionHints: source.roleActionHints || source.actionHints || [],
        adminActionHints: source.adminActionHints || source.actionHints || [],
        roleAvailableExecutors: source.roleAvailableExecutors || [],
        adminAvailableExecutors: source.adminAvailableExecutors || []
    };
}

function normalizeLinkedRequestRules(requestData) {
    const source = requestData || {};
    const fallbackRules = source.available_linked_request_rules || [];

    return {
        roleAvailableLinkedRequestRules:
            source.roleAvailableLinkedRequestRules ||
            source.role_available_linked_request_rules ||
            fallbackRules,
        adminAvailableLinkedRequestRules:
            source.adminAvailableLinkedRequestRules ||
            source.admin_available_linked_request_rules ||
            fallbackRules
    };
}

function isAdminProjectionActive(request, adminGodModeEnabled) {
    return request && request.isAdmin === true && adminGodModeEnabled === true;
}

function getActiveProjection(request, adminGodModeEnabled) {
    const useAdminMode = isAdminProjectionActive(request, adminGodModeEnabled);

    return {
        permissions: useAdminMode
            ? (request.adminPermissions || request.permissions || {})
            : (request.rolePermissions || request.permissions || {}),
        availableActions: useAdminMode
            ? (request.adminAvailableActions || request.adminActions || request.availableActions || [])
            : (request.roleAvailableActions || request.roleActions || request.availableActions || []),
        actionHints: useAdminMode
            ? (request.adminActionHints || request.actionHints || [])
            : (request.roleActionHints || request.actionHints || []),
        availableExecutors: useAdminMode
            ? (request.adminAvailableExecutors || [])
            : (request.roleAvailableExecutors || []),
        linkedRequestRules: useAdminMode
            ? (
                request.adminAvailableLinkedRequestRules ||
                request.admin_available_linked_request_rules ||
                request.available_linked_request_rules ||
                []
            )
            : (
                request.roleAvailableLinkedRequestRules ||
                request.role_available_linked_request_rules ||
                request.available_linked_request_rules ||
                []
            )
    };
}

export function normalizeRequestForCard(requestData, actionsData) {
    const actions = normalizeActionsData(actionsData);
    const linkedRules = normalizeLinkedRequestRules(requestData);

    return cloneRequestData({
        ...(requestData || {}),
        permissions: actions.rolePermissions,
        availableActions: actions.roleAvailableActions,
        actionHints: actions.roleActionHints,
        isAdmin: actions.isAdmin,
        currentUserRole: actions.currentUserRole,
        rolePermissions: actions.rolePermissions,
        adminPermissions: actions.adminPermissions,
        roleAvailableActions: actions.roleAvailableActions,
        adminAvailableActions: actions.adminAvailableActions,
        roleActionHints: actions.roleActionHints,
        adminActionHints: actions.adminActionHints,
        roleAvailableExecutors: actions.roleAvailableExecutors,
        adminAvailableExecutors: actions.adminAvailableExecutors,
        roleAvailableLinkedRequestRules: linkedRules.roleAvailableLinkedRequestRules,
        adminAvailableLinkedRequestRules: linkedRules.adminAvailableLinkedRequestRules
    });
}

export function cloneRequestForStorage(request) {
    return cloneRequestData(request);
}

export function applyActiveRequestMode(state) {
    if (!state.request) {
        state.availableExecutors = [];
        return;
    }

    const projection = getActiveProjection(state.request, state.adminGodModeEnabled);
    state.request.permissions = projection.permissions;
    state.request.availableActions = asArray(projection.availableActions);
    state.request.actionHints = asArray(projection.actionHints);
    state.request.available_linked_request_rules = asArray(projection.linkedRequestRules);
    state.availableActions = state.request.availableActions;
    state.availableExecutors = asArray(projection.availableExecutors);
}

export function setProjectionExecutors(state, executors) {
    const list = asArray(executors);
    state.availableExecutors = list;

    if (!state.request) {
        return;
    }

    if (isAdminProjectionActive(state.request, state.adminGodModeEnabled)) {
        state.request.adminAvailableExecutors = list;
    } else {
        state.request.roleAvailableExecutors = list;
    }
}
